import {
  ConfigApi,
  DiscoveryApi,
  FetchApi,
  IdentityApi,
} from '@backstage/core-plugin-api';

import { FeedbackApi } from './FeedbackApi';
import { Feedback, FeedbackResponse } from './types';

export class FeedbackClient implements FeedbackApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: {
    discoveryApi: DiscoveryApi;
    configApi: ConfigApi;
    identityApi: IdentityApi;
    fetchApi: FetchApi;
  }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async submitFeedback(feedback: Feedback): Promise<void> {
    try {
      const baseUrl = await this.discoveryApi.getBaseUrl('openfeedback'); // calls backend plugin
      const resp = await this.fetchApi.fetch(`${baseUrl}/feedback`, {
        method: 'POST',
        body: JSON.stringify(feedback),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!resp.ok) {
        const errorText = await resp.text();
        throw new Error(`Failed to submit feedback due to API error: ${errorText}`);
      }
    } catch (error: any) {
      throw new Error(`Failed to submit feedback due to unknown error: ${error.message}`);
    }
  }

  async getAllFeedback(): Promise<FeedbackResponse[]> {
    try {
      const baseUrl = await this.discoveryApi.getBaseUrl('openfeedback'); // calls backend plugin
      const resp = await this.fetchApi.fetch(`${baseUrl}/feedback`);

      if (!resp.ok) {
        const errorText = await resp.text();
        throw new Error(`Failed to fetch feedback due to API error: ${errorText}`);
      }

      const data = await resp.json();
      return data;
    } catch (error: any) {
      throw new Error(`Failed to fetch feedback due to unkown error: ${error.message}`);
    }
  }
}